import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
} from 'reactstrap';
import Form from './components/form';
import Confirm from '../../../shared/components/Confirm';
import {
  savePlanning,
  getPlanning,
  listOldPlannings,
  fetchPlanningFormData,
  download,
} from '../../../redux/actions/planningActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';

class IndexContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.handleDownload.bind(this);

    this.state = {
      page: 1,
      changed: false,
      loading: false,
      loadingPage: false,
      duracionActividad: [],
      oldPlannings: [],
      createPlanning: false,
      planning: {
        objetivosMaterias: [],
        cronogramaClases: [],
        practicasLaboratorios: [],
        proyectosTrabajosPracticos: [],
        actividadesComplementarias: [],
        horasLaboratorioSemanal: 0,
        horasPracticaSemanal: 0,
        horasTeoriaSemanal: 0,
        totalHorasSemanal: 0,

        preRequisitos: [],
        finEditarPlaneamiento: '',
        canEditarPlaneamiento: false,
      },
    };
  }

  componentDidMount() {
    this.fetchFormData();
    this.fetchCurrentRecord();
  }

  setPlanning(planning) {
    const {
      objetivosMaterias = [],
      cronogramaClases = [],
      practicasLaboratorios = [],
      proyectosTrabajosPracticos = [],
      actividadesComplementarias = [],
      profesores = [],
    } = planning;

    const { planning: oldPlanning } = this.state;

    this.setState({
      planning: {
        ...planning,
        profesores: profesores.length === 0 ? oldPlanning.profesores : profesores,
        objetivosMaterias: objetivosMaterias.map((h, index) => ({ ...h, index })),
        cronogramaClases: cronogramaClases.map((h, index) => ({ ...h, index })),
        practicasLaboratorios: practicasLaboratorios.map((h, index) => ({ ...h, index })),
        proyectosTrabajosPracticos: proyectosTrabajosPracticos.map((h, index) => ({ ...h, index })),
        actividadesComplementarias: actividadesComplementarias.map((h, index) => ({ ...h, index })),
      },
      loadingPage: false,
      changed: false,
    });
  }

  handleDownload = () => {
    this.setState({
      loading: true,
    });

    const { planningId } = this.props;

    download({
      id: planningId,
      onSuccess: () => this.setState({
        loading: false,
      }),
      onError: () => {
        this.setState({
          loading: false,
        });

        createErrorMessage('Error al intentar descargar el planeamiento');
      },
    });
  }

  fetchCurrentRecord = (newPage) => {
    const { planningId } = this.props;
    const page = newPage || 1;

    if (!planningId) {
      this.setState({
        planning: {
          materiaPeriodoId: 0,
          objetivosMaterias: [],
          cronogramaClases: [],
          practicasLaboratorios: [],
          proyectosTrabajosPracticos: [],
          actividadesComplementarias: [],
          horarios: [],
          profesores: [],
        },
        changed: false,
      });

      return;
    }
    if (!newPage) {
      this.setState({
        loading: true,
      });
    } else {
      this.setState({
        loadingPage: true,
      });
    }

    getPlanning({
      id: planningId,
      page,
      onSuccess: (planning) => {
        const createPlanning = Object.keys(planning).length === 4;
        if (createPlanning) {
          this.fetchOldPlannings(planning.materiaMallaId);
        }

        this.setPlanning(planning);
        this.setState({
          loading: false,
          loadingPage: false,
          page,
          createPlanning,
          changed: false,
        });
      },
      onError: (error) => {
        this.setState({
          loading: false,
          loadingPage: false,
          page,
        });

        if (error && error.status === 404) {
          createErrorMessage('La planeamiento no existe');
        } else {
          createErrorMessage('Error al intentar cargar los datos del planeamiento');
        }
      },
    });
  }

  fetchOldPlannings = (materiaMallaId) => {
    this.setState({
      loading: true,
    });

    if (!materiaMallaId) {
      this.setState({
        loading: false,
        oldPlannings: [],
      });
      return;
    }

    listOldPlannings({
      materiaMallaId,
      onSuccess: (oldPlannings = []) => {
        this.setState({
          oldPlannings,
          loading: false,
        });
      },
      onError: () => {
        this.setState({
          loading: false,
          oldPlannings: [],
        });

        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  fetchFormData = () => {
    this.setState({
      loading: true,
    });
    fetchPlanningFormData({
      onSuccess: ({ DuracionActividad }) => {
        this.setState({
          duracionActividad: DuracionActividad,
          loading: false,
        });
      },
      onError: () => {
        this.setState({
          loading: false,
        });

        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleAddItemArray = ({ name }) => {
    const { planning } = this.state;
    const items = planning[name];

    const newIndex = items.length === 0
      ? 0
      : (Math.max(...items.map(({ index }) => index)) + 1);

    this.setState({
      changed: true,
      planning: {
        ...planning,
        [name]: [
          ...items,
          {
            id: 0,
            index: newIndex,
          },
        ],
      },
    });
  }

  handleDeleteItemArray = ({ name, index }) => {
    const { planning } = this.state;
    const items = planning[name];

    Confirm({
      title: 'Eliminar el item',
      question: (<>&iquest;Deseas eliminar el item seleccionado?.</>),
      yesLabel: 'Si, eliminar',
      noLabel: 'No, cancelar',
      onConfirm: () => {
        const newArray = items.map(h => ({
          ...h,
          deleted: h.deleted || h.index === index,
        }));

        this.setState({
          changed: true,
          planning: {
            ...planning,
            [name]: newArray,
          },
        });
      },
      onCancel: () => ({}),
    });
  }

  handleChangeText = ({ name, target, index = null }) => {
    const value = target.type === 'number'
      ? Number(target.value)
      : `${target.value}`.trim();

    if (Number.isInteger(index)) {
      const { planning } = this.state;
      const items = planning[name];

      const newArray = [...items];
      newArray[index] = {
        ...newArray[index],
        ...{
          [target.name.split('.')[1]]: value,
        },
      };

      this.setState({
        changed: true,
        planning: {
          ...planning,
          [name]: newArray,
        },
      });

      return;
    }

    this.setState(prev => ({
      changed: true,
      planning: {
        ...prev.planning,
        ...{
          [target.name]: value,
        },
      },
    }));
  };

  handleChangeSelect = ({
    option, name, target, index,
  }) => {
    const { planning } = this.state;
    const items = planning[name];

    const newArray = [...items];
    const data = {
      [target.name.split('.')[1]]: option,
      index,
    };

    newArray[index] = {
      ...newArray[index],
      ...data,
    };

    this.setState(prev => ({
      changed: true,
      planning: {
        ...prev.planning,
        ...{
          [name]: newArray,
        },
      },
    }));
  };

  setPage = (page) => {
    this.fetchCurrentRecord(page);
  }

  nextPage = () => {
    const { page } = this.state;
    this.setPage(page + 1 < 10 ? page + 1 : 1);
  };

  previousPage = () => {
    const { page } = this.state;
    this.setPage(page - 1 > 0 ? page - 1 : 9);
  };

  handleCopyLastPlanning = (values) => {
    this.handleSubmit(values);
  };

  handleSubmit = (values) => {
    if (!values) {
      console.log(values);

      return;
    }

    const { materiaPeriodo } = this.props;
    const { changed, createPlanning, oldPlannings } = this.state;

    if (!createPlanning && (!materiaPeriodo.canEditarPlaneamiento || !changed)) {
      this.nextPage();
      return;
    }

    const { oldMateriaPeriodoId, isNew = false } = values;

    const oldPlanning = oldPlannings.find(o => o.id === oldMateriaPeriodoId);

    if (!isNew) {
      this.setState({
        loadingPage: true,
      });

      const {
        page,
        cronogramaClases = [],
        practicasLaboratorios = [],
      } = values;

      const { planningId: materiaPeriodoId } = this.props;

      savePlanning({
        page: `page${createPlanning ? 1 : page}`,
        paylaod: {
          ...values,
          materiaPeriodoId,
          cronogramaClases: cronogramaClases.map(({
            contenidos,
            deleted,
            fecha,
            id,
            profesorMateria,
            unidad,
          }) => ({
            materiaPeriodoId,
            contenidos,
            deleted,
            fecha: !fecha || fecha === '0001-01-01' ? null : fecha,
            id,
            profesorMateria,
            unidad,
          })),
          practicasLaboratorios: practicasLaboratorios.map(pl => ({
            ...pl,
            materiaPeriodoId,
          })),
        },
        onSuccess: () => {
          this.nextPage();

          createSuccessMessage('Datos de planeamiento guardado exitosamente');
        },
        onError: (error) => {
          if (error.message) {
            createWarningMessage(error.message);
          } else if (error.errors) {
            Object.entries(error.errors).flatMap(([, message]) => createWarningMessage(message));
          } else {
            createErrorMessage('Ocurrió un error al intentar guardar el planeamiento');
          }

          this.setState({
            loadingPage: false,
          });
        },
      });

      return;
    }

    Confirm({
      title: oldMateriaPeriodoId ? 'Copiar Planeamiento' : 'Crear Planeamiento',
      question: (
        <>
          &iquest;Deseas
          {oldMateriaPeriodoId ? ' copiar el' : ' crear un nuevo'} planeamiento
          <b>{oldPlanning ? ` ${oldPlanning.anho}/${oldPlanning.seccion}` : ''}</b>?.
        </>
      ),
      yesLabel: oldMateriaPeriodoId ? 'Si, Copiar' : 'Si, Crear',
      noLabel: 'No',
      color: 'primary',
      onConfirm: () => {
        this.setState({
          loadingPage: true,
        });

        const {
          page,
          cronogramaClases = [],
          practicasLaboratorios = [],
        } = values;

        const { planningId: materiaPeriodoId } = this.props;

        savePlanning({
          page: `page${createPlanning ? 1 : page}`,
          paylaod: {
            ...values,
            materiaPeriodoId,
            cronogramaClases: cronogramaClases.map(({
              contenidos,
              deleted,
              fecha,
              id,
              profesorMateria,
              unidad,
            }) => ({
              materiaPeriodoId,
              contenidos,
              deleted,
              fecha: !fecha || fecha === '0001-01-01' ? null : fecha,
              id,
              profesorMateria,
              unidad,
            })),
            practicasLaboratorios: practicasLaboratorios.map(pl => ({
              ...pl,
              materiaPeriodoId,
            })),
          },
          onSuccess: () => {
            this.nextPage();

            createSuccessMessage('Datos de planeamiento guardado exitosamente');
          },
          onError: (error) => {
            if (error.message) {
              createWarningMessage(error.message);
            } else if (error.errors) {
              Object.entries(error.errors).flatMap(([, message]) => createWarningMessage(message));
            } else {
              createErrorMessage('Ocurrió un error al intentar guardar el planeamiento');
            }

            this.setState({
              loadingPage: false,
            });
          },
        });
      },
      onCancel: () => {
        //
      },
    });
  }

  render() {
    const {
      materiaPeriodo,
    } = this.props;

    const {
      planning,
      loading,
      loadingPage,
      duracionActividad,
      page,
      changed,
      createPlanning,
      oldPlannings,
    } = this.state;

    if (loading || !planning || !materiaPeriodo || duracionActividad.length === 0) {
      return (
        <LoadingSpinner />
      );
    }

    return (
      <Container>
        <Row>
          <Form
            {...planning}
            materiaPeriodo={materiaPeriodo}
            oldPlannings={oldPlannings}
            duracionActividad={duracionActividad}
            createPlanning={createPlanning}
            onSubmit={this.handleSubmit}
            onCopyLastPlanning={this.handleCopyLastPlanning}
            loading={loading}
            loadingPage={loadingPage}
            initialValues={planning}

            onAddItemArray={this.handleAddItemArray}
            onDeleteItemArray={this.handleDeleteItemArray}
            onChangeText={this.handleChangeText}
            onChangeSelect={this.handleChangeSelect}
            onDownload={this.handleDownload}

            changed={changed}
            page={page}
            setPage={this.setPage}
            previousPage={this.previousPage}
            nextPage={this.nextPage}

            enableReinitialize
          />
        </Row>
      </Container>
    );
  }
}

IndexContainer.propTypes = {
  materiaPeriodo: PropTypes.shape({}).isRequired,
  planningId: PropTypes.number.isRequired,
};

export default IndexContainer;
